import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/ParkGate/v4ward/car/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/ParkGate/v4ward/car/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/ParkGate/v4ward/car/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/ParkGate/v4ward/car/submit', params, options);

export const update = (params, options) =>
  request.post('/api/ParkGate/v4ward/car/submit', params, options);
